module.exports = __webpack_public_path__ + "4bbd5e862bb9fbd9de8bfdfd84777595.jpg";